
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class Rioplay8AllowedDevicesDialog extends Serenity.EntityDialog<Rioplay8AllowedDevicesRow, any> {
        protected getFormKey() { return Rioplay8AllowedDevicesForm.formKey; }
        protected getIdProperty() { return Rioplay8AllowedDevicesRow.idProperty; }
        protected getLocalTextPrefix() { return Rioplay8AllowedDevicesRow.localTextPrefix; }
        protected getNameProperty() { return Rioplay8AllowedDevicesRow.nameProperty; }
        protected getService() { return Rioplay8AllowedDevicesService.baseUrl; }
        protected getDeletePermission() { return Rioplay8AllowedDevicesRow.deletePermission; }
        protected getInsertPermission() { return Rioplay8AllowedDevicesRow.insertPermission; }
        protected getUpdatePermission() { return Rioplay8AllowedDevicesRow.updatePermission; }

        protected form = new Rioplay8AllowedDevicesForm(this.idPrefix);

    }
}